import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { fetchAllDoctors } from "../../services/api";

export default function DoctorProfile() {
    const { id } = useParams();
    const navigate = useNavigate();
  

    const [doctor, setDoctor] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        // In a real app we would have fetchDoctorById(id)
        // For now we fetch all and filter to match the existing API structure
        fetchAllDoctors()
            .then(data => {
                const found = data.find(d => String(d.id) === String(id));
                if (found) {
                    setDoctor(found);
                } else {
                    setError("Doctor not found");
                }
                setLoading(false);
            })
            .catch(err => {
                setError("Failed to load doctor profile");
                setLoading(false);
            });
    }, [id]);

    if (loading) return <div style={{ padding: 40, marginTop: 64, textAlign: 'center' }}>Loading profile...</div>;
    if (error) return <div style={{ padding: 40, marginTop: 64, color: 'red', textAlign: 'center' }}>{error}</div>;
    if (!doctor) return <div style={{ padding: 40, marginTop: 64, textAlign: 'center' }}>Doctor not found</div>;

    return (
        <section style={{ padding: 40, marginTop: 64, maxWidth: 800, margin: '64px auto 0' }}>
            <button
                onClick={() => navigate(-1)}
                style={{ marginBottom: 24, background: '#f5f5f5', border: '1px solid #ddd', padding: '8px 16px', borderRadius: 4, cursor: 'pointer' }}
            >
                ← Back
            </button>

            <div style={{ background: '#fff', borderRadius: 12, padding: 32, boxShadow: '0 4px 12px rgba(0,0,0,0.05)' }}>
                <div style={{ display: 'flex', gap: 24, alignItems: 'center', marginBottom: 32 }}>
                    <div style={{ width: 100, height: 100, borderRadius: '50%', background: '#1976d2', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 36, fontWeight: 'bold' }}>
                        {(doctor.first_name?.[0] || '') + (doctor.last_name?.[0] || '')}
                    </div>
                    <div>
                        <h2 style={{ margin: '0 0 8px 0', fontSize: 28, color: '#333' }}>
                            {doctor.first_name} {doctor.last_name}
                        </h2>
                        <p style={{ margin: 0, fontSize: 18, color: '#666' }}>
                            {doctor.specialty} • {doctor.city || 'Tunis'}
                        </p>
                        <div style={{ marginTop: 8, display: 'flex', gap: 12, alignItems: 'center' }}>
                            <span style={{ background: doctor.available ? '#e8f5e9' : '#ffebee', color: doctor.available ? '#2e7d32' : '#c62828', padding: '4px 12px', borderRadius: 16, fontSize: 14, fontWeight: 500 }}>
                                {doctor.available ? 'Available' : 'Unavailable'}
                            </span>
                            <span style={{ fontSize: 16, fontWeight: 600, color: '#1976d2' }}>
                                {doctor.consultation_fee ? `${doctor.consultation_fee} TND` : "TBD"}
                            </span>
                        </div>
                    </div>
                </div>

                <div style={{ marginBottom: 32 }}>
                    <h3 style={{ borderBottom: '1px solid #eee', paddingBottom: 8, marginBottom: 16 }}>About</h3>
                    <p style={{ lineHeight: 1.6, color: '#555' }}>
                        {doctor.bio || `Dr. ${doctor.last_name} is a dedicated ${doctor.specialty || 'medical professional'} located in ${doctor.city || 'Tunis'} with over ${doctor.experienceYears || 5} years of experience. They are committed to providing the best care for their patients.`}
                    </p>
                </div>

                <div style={{ display: 'flex', gap: 16 }}>
                    <button
                        onClick={() => navigate('/appointments/request')}
                        style={{ flex: 1, background: '#1976d2', color: '#fff', border: 'none', padding: '12px 24px', borderRadius: 6, fontSize: 16, cursor: 'pointer', fontWeight: 'bold' }}
                    >
                        Request Appointment
                    </button>
                </div>
            </div>
        </section>
    );
}
